import { FilterSetType } from '@statsbomb/parachute-types';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { hudlUserIdUserNameMapAtom, userDetailsAtom } from '@/atoms/queries/user';
import { filterSetsAtom } from '@/atoms/queries/userConfigs';
import { SYSTEM_WIDE_USER_ID } from '@/consts/userConfigs';

export const useFilterSets = (filterSetType: FilterSetType) => {
  const { t } = useTranslation(['general']);
  const userDetails = useAtomValue(userDetailsAtom);
  const currentUserId = userDetails.user.hudlUserId;

  const filterSets = useAtomValue(filterSetsAtom);
  const filteredFilterSets = filterSets.filter(filterSet => filterSet.type === filterSetType);
  const hudlUserIdUserNameMap = useAtomValue(hudlUserIdUserNameMapAtom);

  const filterSetOwnerName = (hudlUserId: string) => {
    if (hudlUserId === SYSTEM_WIDE_USER_ID) return 'Hudl Statsbomb';
    if (currentUserId === hudlUserId) return t('me');
    return hudlUserIdUserNameMap[hudlUserId] || t('deactivated');
  };

  const formattedFilterSets = filteredFilterSets.map(filterSet => ({
    ...filterSet,
    ownerName: filterSetOwnerName(filterSet.hudlUserId),
  }));

  return formattedFilterSets;
};
